<template>
    <div class="custom-banner-management">
        <b-button
            class="btn-banner-upload"
            id="bannerUpload"
            variant="primary"
            @click="$refs.bannerUpload.$el.childNodes[0].click()"
            :disabled="disabled">
            <i class="btn-camera-icon"></i>{{ $t('banner.add_banner') }}
        </b-button>
        <b-form-file
            id="upload-custom-timeline-banner"
            v-show="false"
            v-model="file"
            ref="bannerUpload"
            :placeholder="'Banner'"
            accept="image/jpeg"
            @change="onFileChange">
        </b-form-file>
    </div>
</template>

<script>
export default {
    name: 'design-2021-custom-banner-upload-widget-component',
    props: {
        bannerIn: {
            type: Object,
            default: function () {
                return {};
            },
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            banner: this.bannerIn === null ? {} : this.bannerIn,
            file: null,
        };
    },

    methods: {
        onFileChange(evt) {
            this.saveBanner(evt.target.files[0]);
        },

        saveBanner(file) {
            if (file === null) {
                return;
            }

            const data = new FormData();
            const options = {
                headers: { 'Content-Type': 'multipart/form-data' },
            };

            data.append('file', file);

            this.alert.saving();
            axios.post(this.routes.profileBannerUpload(), data, options).then(
                (response) => {
                    this.alert.success();
                    window.location.reload();
                },
                (error) => {
                    if (error.response?.data?.errors?.banner) {
                        this.alert.ajaxError(
                            this.$t('components.upload_failed'),
                            this.$t('components.check_if_the_banner_is_a_jpeg_file'),
                            false,
                        );
                    } else {
                        this.alert.ajaxError(error);
                    }
                },
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.custom-banner-management {
    margin-left: map-get($grid-gutter-spacing, 'fifteen');

    &:nth-child(2) {
        margin-left: auto;
    }
}

.btn-banner-upload {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: $default-font-size;
    line-height: 1;
    background-color: $white;
    color: var(--primary);
    border: $white;

    i {
        font-style: normal;
    }

    &:hover,
    &:active,
    &:not(:disabled):not(.disabled):active {
        background-color: darken($white, 10%);
        color: var(--primary);
        outline: none;
        border-color: $white;
    }

    &:active:focus,
    &:not(:disabled):not(.disabled):active:focus {
        box-shadow: 0 0 0 0.2rem rgba($white, 0.5);
    }
}
</style>
